export const mutations = {
    setNfe(state, nfe) {
        state.nfe = nfe
    },
    setNfes(state, nfes) {
        state.nfes = nfes
    },
    addNfe(state, data){
        state.nfes.push(data)
    },
    removeNfe(state, data){
        let index = state.nfes.map(x => x.id).indexOf(data.id);
        state.nfes.splice(index, 1)
    },
    setModalGerarNfe(state, status) {
        state.modalGerarNfe = status
    },
    setModalGerarNfce(state, status) {
        state.modalGerarNfce = status
    },
    setModalCancelarNfe(state, status) {
        state.modalCancelarNfe = status
    },
    setModalCancelarNfce(state, status) {
        state.modalCancelarNfce = status
    },
    setModalEstornoNfe(state, status) {
        state.modalEstornoNfe = status
    },
    setModalCartaCorrecaoNfe(state, status) {
        state.modalCartaCorrecaoNfe = status
    },
    setModalEnviarNfeEmail(state, status) {
        state.modalEnviarNfeEmail = status
    },
    setNfce(state, data){
        state.nfce = data
    }
}

export default {}